import { library, IconName as faIconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const fortawesome = {
	library: library,
	FontAwesomeIcon: FontAwesomeIcon,
};

export type IconName = faIconName;